import { useState } from "react";
import { changeCurrentPassword } from "../firebase/services";
import { useLanguage } from "../hooks/useLanguage";

export default function ChangePasswordModal({ onClose }) {
  const { t } = useLanguage();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault(); setError("");
    if (form.next.length < 6) { setError(t("auth.pw_min")); return; }
    if (form.next !== form.confirm) { setError(t("auth.pw_mismatch")); return; }
    setLoading(true);
    try {
      await changeCurrentPassword(form.current, form.next);
      setSuccess(true);
    } catch (err) {
      if (err.code === "auth/wrong-password" || err.code === "auth/invalid-credential") {
        setError("Mật khẩu hiện tại không đúng.");
      } else {
        setError(t("common.error") + ": " + err.message);
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <span className="modal-title">🔑 {t("auth.change_pw")}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        {success ? (
          <div style={{ padding: "24px 0", textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>{t("auth.pw_changed")}</div>
            <button className="btn btn-primary" onClick={onClose}>{t("common.close")}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error" style={{ marginBottom: 12 }}>{error}</div>}
            <div className="form-group">
              <label className="form-label">{t("auth.current_pw")}</label>
              <input type="password" value={form.current} onChange={set("current")} placeholder="••••••••" required />
            </div>
            <div className="form-group">
              <label className="form-label">{t("auth.new_pw")}</label>
              <input type="password" value={form.next} onChange={set("next")} placeholder={t("auth.pw_min")} required />
            </div>
            <div className="form-group">
              <label className="form-label">{t("auth.confirm_pw")}</label>
              <input type="password" value={form.confirm} onChange={set("confirm")} placeholder="••••••••" required />
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? t("auth.pw_changing") : t("auth.pw_change_btn")}
              </button>
              <button className="btn" type="button" onClick={onClose}>{t("common.cancel")}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
